import { render } from "./HomeBanner.vue?vue&type=template&id=f5d8565e&scoped=true"
import script from "./HomeBanner.vue?vue&type=script&lang=js"
export * from "./HomeBanner.vue?vue&type=script&lang=js"

import "./HomeBanner.vue?vue&type=style&index=0&id=f5d8565e&lang=scss&scoped=true"

import exportComponent from "/Users/mis/0_Lise/kinpo-website-2021/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5d8565e"]])

export default __exports__